import React from 'react';

import {Icon} from '@gravity-ui/uikit';

import {block} from '../cn';

import {invertHex, strToHexMemoized} from './colorize';
import type {OrganizationIconProps} from './types';

import orgIcon from '../../../assets/icons/org.svg';

import './OrganizationIcon.scss';

const b = block('organization-icon');

// TODO(golbahsg): Use Avatar component for rendering
export const OrganizationIcon: React.FC<OrganizationIconProps> = ({
    orgId,
    size,
    icon = orgIcon,
    iconSize = '100%',
    className,
}) => {
    const style = React.useMemo(() => {
        const backgroundColor = strToHexMemoized(orgId);
        const color = invertHex(backgroundColor);

        const result = {
            color,
            backgroundColor,
        };

        if (typeof size === 'number') {
            Object.assign(result, {
                width: `${size}px`,
                height: `${size}px`,
            });
        }

        return result;
    }, [orgId, size]);

    return (
        <div className={b(null, className)} style={style}>
            <Icon className={b('icon')} data={icon} size={iconSize} />
        </div>
    );
};
